import React, { lazy, Suspense } from 'react';
import type { Question } from '../../types/questionnaire';

interface Props {
  question: Question;
  onChecked: (id: number) => void;
}

const QuestionLazy = lazy(() => import('../Question'));

const QuestionNew = (props: Props) => (
  <Suspense fallback={<div>Loading...</div>}>
    <QuestionLazy {...props} />
  </Suspense>
);

export default QuestionNew;
